/* eslint-disable camelcase */
/* eslint-disable padding-line-between-statements */
/* eslint-disable unicorn/filename-case */
import React, { useCallback, useContext, useState, useEffect } from 'react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import _ from 'lodash';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss';
import { TWIAStandardizeButton, TWIAStandardizationStatus } from 'twia-capability-address-component';
import { LocaleService_TWIA } from 'twia-capability-locale';
import StandardAddressValidationUtil from "twia-capability-address-component/util/StandardAddressValidationUtil";
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { __ } from 'lodash/fp';
import metadata from './PayorComponent.metadata.json5';
import messages from '../../../../../modules-react/twia-capability-address-component/addressMessages.messages';
import addressControl from '../../../../../modules-react/twia-capability-address-component/util/addressControl';

function PayorComponent(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const { submissionVM, updateSubmissionVM, country, showErrors, findInvalidComponent, onValidate, isStandardizationDisabled, isButtonDisabled, onAddressEdit } = props;
    const [regex, setRegex] = useState('');
    const [zipCodevalidationMsg, setZipCodeValidationMsg] = useState([]);
    const [addInsVM, setAddInsVM] = useState([_.get(submissionVM, 'bindData_TFPA.additionalInterests_Ext.children[0].value')]);
    const [showAddressValidationStatus, setStatus] = useState(false);
    const [selectedValue, setSelectedValue] = useState('');
    const [valMsg, setValMsg] = useState([]);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('PayorComponent');
    const mortgageeAddress = addInsVM?.accountContactDTO?.primaryAddress;
    const selectedUWCompany = _.get(submissionVM, 'baseData.associationName_TWIA.value.code');
    const getAccountHolder = _.get(submissionVM, 'baseData.accountHolder.value');
    const policyTypeCode = _.get(submissionVM, 'lobData.homeowners_tfpa.policyType_TWIA.value.code');
    const primaryAddress = _.get(submissionVM, 'baseData.policyAddress');
    const viewModelService = useContext(ViewModelServiceContext);
    const getBillingAddress = _.get(submissionVM, 'bindData_TFPA.billingAddress.value');
    const getPolicyAddress = _.clone(_.get(submissionVM, 'baseData.policyAddress.value'));
    const [noMatchFound, setNoMatchFound] = useState(false);
    const xPortal = 'PE';
    const countryCode = 'US';

    useEffect(() => {
        if (!isComponentValid) {
            onValidate(isComponentValid, 'PayorComponent');
        }
    }, [isComponentValid, onValidate]);
    useEffect(() => {
        findInvalidComponent(isComponentValid, 'PayorComponent');
    }, [findInvalidComponent, isComponentValid])

    useEffect(() => {
        const val = submissionVM.bindData_TFPA.billingAddress?.value || submissionVM.bindData_TFPA.billingAddress; //DE17215
        setNoMatchFound(val.addressStandResult?.noAddressMatchFound);
        getAddressConfig(countryCode);
    }, [submissionVM]);

    useEffect(() => {
        createHOVMData();
        const mortgageeAddlInterests = submissionVM.bindData_TFPA.additionalInterests_Ext
            .value.filter((ai) => _.find(ai.hoadditionalInterestDetails, (hoAd) =>
                hoAd.type === 'MORTGAGEE' || hoAd.type === 'MORTGAGEEESCROW_EXT'));
        const firstMortgageePos = 'FirstMortgagee';
        const firstFound = _.find(mortgageeAddlInterests, (interest) =>
            _.find(interest.hoadditionalInterestDetails, (ho) => ho.mortgagePosition_ext === firstMortgageePos));
        setAddInsVM(firstFound);

        if (_.isUndefined(selectedValue)) {
            setValMsg([translator(messages.required)]);
            setComponentValidation(false);
        }
    }, [])

    const payerCreator = useCallback((payer, context) => {
        return viewModelService.create(payer, 'pc', 'org.tfpa.edge.capabilities.quote.submission.TFPAContactRoleDTO', context);
    }, []);

    const updatePrimaryAddress = () => {
        _.set(submissionVM, 'bindData_TFPA.payor_Ext.accountContactDTO.primaryAddress', getBillingAddress);
        updateSubmissionVM(submissionVM);
    };

    //US26840
    const onPayorChange = useCallback((value, path) => {

        setSelectedValue(value);
        setValMsg([]);
        setComponentValidation(true);
        if (value === 'alternatepayor_person') {
            createAddressVMData();
            _.set(submissionVM, "bindData_TFPA.portalPayorType_Ext.value", value);
            _.set(submissionVM, "bindData_TFPA.payorType_Ext.value", "alternatepayor");
            const subType = "Person";
            const contactRole = createPayer(subType);
            // _.set(submissionVM, 'bindData_TFPA.payor_Ext.subtype.value', 'PolicyAddlInterest');
            // _.set(submissionVM, 'bindData_TFPA.payor_Ext.accountContactDTO.value', contactRole.accountContactDTO.value);
            submissionVM.value.bindData_TFPA.payor_Ext = {
                accountContactDTO: contactRole.accountContactDTO.value,
                subtype: 'PolicyAddlInterest'
            };
            createHOVMData();
            onAddressEdit(true);
        } else if (value === 'alternatepayor_estate/trust' || value === 'alternatepayor_company') {
            createAddressVMData();
            _.set(submissionVM, "bindData_TFPA.portalPayorType_Ext.value", "alternatepayor_company");
            _.set(submissionVM, "bindData_TFPA.payorType_Ext.value", "alternatepayor");
            const subType = "Company";
            const contactRole = createPayer(subType);
            _.set(submissionVM, 'bindData_TFPA.payor_Ext.subtype.value', 'PolicyAddlInterest');
            _.set(submissionVM, 'bindData_TFPA.payor_Ext.accountContactDTO.value', contactRole.accountContactDTO.value);
            submissionVM.value.bindData_TFPA.payor_Ext = {
                accountContactDTO: contactRole.accountContactDTO.value,
                subtype: 'PolicyAddlInterest'
            };
            createHOVMData();
            onAddressEdit(true);
        } else if (value === 'primarynameinsured') {
            _.set(submissionVM, "bindData_TFPA.payor_Ext.value", {});
            _.set(submissionVM, "bindData_TFPA.portalPayorType_Ext.value", value);
            _.set(submissionVM, "bindData_TFPA.payorType_Ext.value", "primarynameinsured");
            _.set(submissionVM, "bindData_TFPA.payor_Ext.accountContactDTO", getAccountHolder);
            _.set(submissionVM, 'bindData_TFPA.billingAddress.value', getPolicyAddress);
            _.set(submissionVM, 'bindData_TFPA.billingAddress.mustStandardize_Ext.value', false);
            updateSubmissionVM(submissionVM);
            onAddressEdit(false);
        } else if (value === 'mortgageeescrow') {
            if (_.isUndefined(addInsVM)) {
                setValMsg([translator(messages.mortValidationMessage)]);
                setComponentValidation(false);
            } else {
                createAddressVMData();
                const addInsVMCopy  = _.cloneDeep(addInsVM);
                _.set(submissionVM.value, 'bindData_TFPA.billingAddress', mortgageeAddress);
                _.set(submissionVM.value, 'bindData_TFPA.billingAddress.mustStandardize_Ext', false);
                _.set(submissionVM, 'bindData_TFPA.payor_Ext', addInsVMCopy);
                _.set(submissionVM, "bindData_TFPA.portalPayorType_Ext.value", value);
                _.set(submissionVM, "bindData_TFPA.payorType_Ext.value", "mortgageeescrow");
                _.set(submissionVM, "bindData_TFPA.payor_Ext.subtype", "PolicyAddlInterest");
            }
            onAddressEdit(false);
        }
        updateSubmissionVM(submissionVM);
        setStatus(addressControl.showStatus(submissionVM.bindData_TFPA.billingAddress.value, xPortal));
    }, [setComponentValidation, submissionVM, translator, updateSubmissionVM]);

    const createHOVMData = useCallback(() => {
        const daiType = 'edge.capabilities.policychange.lob.homeowners.coverables.dto.DwellingAdditionalInterestDTO';
        const hoDetail = viewModelService.create({ type: 'ALTERNATEPAYOR_EXT' }, 'pc', daiType);
        const hoDetailArray = [hoDetail.value];
        _.set(submissionVM, 'bindData_TFPA.payor_Ext.hoadditionalInterestDetails', hoDetailArray);
        updateSubmissionVM(submissionVM);
    }, [submissionVM, updateSubmissionVM]);

    const createAddressVMData = useCallback(() => {
        const add = 'edge.capabilities.address.dto.AddressDTO';
        const addDTO = viewModelService.create({}, 'pc', add);
        _.set(submissionVM, 'bindData_TFPA.billingAddress.value', addDTO.value);
        _.set(submissionVM, 'bindData_TFPA.billingAddress.addressType.value', 'mailingExt');
        _.set(submissionVM, 'bindData_TFPA.billingAddress.mustStandardize_Ext.value', true);
        _.set(submissionVM, 'bindData_TFPA.billingAddress.country.value', 'US');
        updateSubmissionVM(submissionVM.value);
    }, [submissionVM, updateSubmissionVM]);


    const createPayer = (n) => {
        const paymentContactRole = payerCreator({
            accountContactDTO: {
                subtype: n,
                primaryAddress: primaryAddress.value
            },
            subtype: 'PolicyAddlInterest'
        }, { 'PAYER_ADDRESS': true });

        return paymentContactRole;
    }

    useEffect(() => {
        const selVal = _.get(submissionVM, "bindData_TFPA.portalPayorType_Ext.value");
        if (selVal === 'alternatepayor_company') {
            setSelectedValue('alternatepayor_estate/trust');
        } else {
            setSelectedValue(selVal);
        }
        if (_.isUndefined(getBillingAddress)) {
            updatePrimaryAddress();
        }
        setStatus(addressControl.showStatus(submissionVM.bindData_TFPA.billingAddress.value, xPortal));
        updateSubmissionVM(submissionVM);
    }, []);

    useEffect(() => {
        if (submissionVM.bindData_TFPA?.billingAddress?.isOverridden_Ext?.value
            && !submissionVM.bindData_TFPA?.billingAddress?.isOverriddenInternally_Ext?.value) {
            StandardAddressValidationUtil.setNotValidated(submissionVM.bindData_TFPA.billingAddress.value);
        }      
    },[]);

    // useEffect(() => {
    //     if (submissionVM.bindData_TFPA?.billingAddress?.isOverridden_Ext?.value
    //         || submissionVM.bindData_TFPA?.billingAddress?.isValidated_Ext?.value) {
    //             onAddressEdit(false);
    //     }      
    // },[]);

    const getAddressConfig = useCallback(
        async (value) => {
            if (authHeader) {
                await LocaleService_TWIA.getLocal_TWIA(value, authHeader).then(
                    (locale) => {
                        setRegex(locale.postalCodeRegex);
                    }
                )
            }
        },
        []);

    const validateRegex = (idRegex, target) => {
        if (idRegex === undefined || idRegex === "") {
            return true
        }
        // eslint-disable-next-line security/detect-non-literal-regexp
        if (idRegex === undefined || idRegex === "") {
            return true
        }
        const regex = new RegExp(`^${idRegex}$`);

        return regex.test(target);
    };

    const validateZipCode = useCallback(() => {
        const code = _.get(submissionVM.bindData_TFPA.billingAddress.value, 'postalCode');
        const isCodevalid = code === "" ? true : validateRegex(regex, code);
        setZipCodeValidationMsg([]);
        if (!isCodevalid) {
            setZipCodeValidationMsg([translator(messages.ZIPCodeValidationMessage)]);
        }
        return '';
    }, [submissionVM, regex]);

    //US26840
    const writeValue = useCallback(
        (value, path) => {
            if (path === 'bindData_TFPA.billingAddress.addressLine1'
                || path === 'bindData_TFPA.billingAddress.addressLine2'
                || path === 'bindData_TFPA.billingAddress.city'
                || path === 'bindData_TFPA.billingAddress.state'
                || path === 'bindData_TFPA.billingAddress.postalCode'
            ) {
                StandardAddressValidationUtil.setNotValidated(submissionVM.bindData_TFPA.billingAddress.value);
                setStatus(addressControl.showStatus(submissionVM.bindData_TFPA.billingAddress.value, xPortal));
                updatePrimaryAddress();
                updateSubmissionVM(submissionVM);

                onAddressEdit(true);
            }
            _.set(submissionVM, path, value);
            updateSubmissionVM(submissionVM);
            updatePrimaryAddress();
        }, [submissionVM, updateSubmissionVM, onAddressEdit]
    );

    const handleStandardizationResponse = useCallback((value) => {
        const val = submissionVM.bindData_TFPA.billingAddress?.value || submissionVM.bindData_TFPA.billingAddress; //DE17215
        if (xPortal === 'CC') {
            setNoMatchFound(val.addressStandResult?.noAddressMatchFound);
        } else {
            setNoMatchFound(value.noAddressMatchFound);
        }
    });

    const updatePrimaryAddressVM = useCallback((value) => {
        _.set(submissionVM, 'bindData_TFPA.billingAddress.value', value);
        _.set(submissionVM, 'bindData_TFPA.payor_Ext.accountContactDTO.primaryAddress.value', value);
        updateSubmissionVM(submissionVM);
        onAddressEdit(false);
    }, [submissionVM, updateSubmissionVM]);


    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        payor1: {  //US26840
            visible: policyTypeCode != 'HO4',
            value: selectedValue,
            validationMessages: valMsg,
            disabled: isButtonDisabled
        },
        payor2: {  //US26840
            visible: policyTypeCode == 'HO4',
            value: selectedValue,
            validationMessages: valMsg,
            disabled: isButtonDisabled
        },
        estate: {
            visible: selectedValue === 'alternatepayor_estate/trust' || selectedValue === 'alternatepayor_company'
        },
        firstName: {
            visible: selectedValue === 'alternatepayor_person'
        },
        lastName: {
            visible: selectedValue === 'alternatepayor_person'
        },
        statusComponent: {
            primaryAddressVM: submissionVM.bindData_TFPA.billingAddress.value, status: showAddressValidationStatus,
            visible: (!_.isNull(selectedValue) && (selectedValue === 'alternatepayor_person' || selectedValue === 'alternatepayor_estate/trust' || selectedValue === 'alternatepayor_company')) && showAddressValidationStatus,
            isStandardizationDisabled,
            noMatchFound
        },
        buttonComponent: {
            visible: !_.isNull(selectedValue) && (selectedValue === 'alternatepayor_person' || selectedValue === 'alternatepayor_estate/trust' || selectedValue === 'alternatepayor_company'),
            primaryAddressVM: submissionVM.bindData_TFPA.billingAddress.value,
            authHeader,
            companyType: selectedUWCompany,
            updatePrimaryAddressVM,
            standardizationResponse: handleStandardizationResponse,
            xPortal,
            zipCodevalidationMsg: zipCodevalidationMsg
        },
        city: {
            visible: (selectedValue === 'alternatepayor_person' || selectedValue === 'alternatepayor_estate/trust' || selectedValue === 'alternatepayor_company')
        },
        state: {
            visible: (selectedValue === 'alternatepayor_person' || selectedValue === 'alternatepayor_estate/trust' || selectedValue === 'alternatepayor_company'),
            placeholder: `-- Choose State --`
        },
        addressLine1: {
            visible: (selectedValue === 'alternatepayor_person' || selectedValue === 'alternatepayor_estate/trust' || selectedValue === 'alternatepayor_company'),
        },
        addressLine2: {
            visible: (selectedValue === 'alternatepayor_person' || selectedValue === 'alternatepayor_estate/trust' || selectedValue === 'alternatepayor_company'),
        },
        addressLine3: {
            visible: (selectedValue === 'alternatepayor_person' || selectedValue === 'alternatepayor_estate/trust' || selectedValue === 'alternatepayor_company'),
        },
        zipCode: {
            visible: (selectedValue === 'alternatepayor_person' || selectedValue === 'alternatepayor_estate/trust' || selectedValue === 'alternatepayor_company'),
            onBlur: validateZipCode,
            validationMessages: zipCodevalidationMsg
        }
    }
    const resolvers = {
        resolveClassNameMap: wizardStyles,
        resolveComponentMap: {
            standardizeButtonComponent: TWIAStandardizeButton,
            standardizeStatusComponent: TWIAStandardizationStatus
        },
        resolveCallbackMap: {
            handlePayorChange: onPayorChange
        },
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={submissionVM}
            overrideProps={overrideProps}
            onValueChange={writeValue}
            onModelChange={updateSubmissionVM}
            onValidationChange={setComponentValidation}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            showErrors={showErrors}
        />
    )
}

export default PayorComponent;